import React, { useEffect, useState } from "react";
import MainContainer from "../../container/MainContainer";
import location from "../../images/location-icon.svg";
import calender from "../../images/calender.svg";
import time from "../../images/time-clock-circle.svg";
import cart from "../../images/Cart.svg";
// import MyResponsiveBar from "../Charts/Bar";
import { Progress } from "react-sweet-progress";
import "react-sweet-progress/lib/style.css";
import MyResponsiveBump from "../Charts/Totalincomechart";
import DatePicker from "react-datepicker";
import { useHistory, Link } from "react-router-dom";
import { GET_EVENT_BY_ID } from "../../query/GetEventById";
import { DELETE_EVENT } from "../../mutation/DeleteEvent";
import { useMutation, useQuery } from "@apollo/client";
import { hasuraClient, monoClient } from "../../apolloClient";
import moment from "moment";
import UserIcons from "../../images/user.png";
import { GET_CATEGORIES } from "../../query/GetCategory";
import DeleteEvent from "../Popup/DeleteEvent";
import Attendees from "../Popup/Attendees";
import Arrow from "../../images/Arrow-Right.svg";
import { GET_EVENT_INCOME_LINE_CHART } from "../../query/getEventLineChart";
import { GET_TICKET_SOLD } from "../../query/getTicketSold";
import { GET_EVENT_LAST_TRANS } from "../../query/getEventLastTrans";
import { GET_REDEEM_DATA } from "../../query/getRedeemData";

const EventFree = (props) => {
  // const [date, setDate] = useState();
  const [modalShowD, setModalShowD] = React.useState(false);
  const [modalShow, setModalShow] = React.useState(false);
  const [startTime, setStartTime] = React.useState(null);
  const [endTime, setEndTime] = React.useState(null);
  const [dates, setDates] = React.useState(null);
  const [category, setCategory] = React.useState(null);
  const [categoryImage, setCategoryImage] = React.useState(null);
  const [graphData, setGraphData] = useState([]);
  const [startDateRange, setStartDateRange] = useState(
    new Date(moment(getPreviousMonday()).format())
  );
  const [endDateRange, setEndDateRange] = useState(new Date(moment().format()));
  const [startDate, setStartDate] = useState(
    moment(getPreviousMonday()).format()
  );
  const [endDate, setEndDate] = useState(moment().format());
  const [diffDay, setDiffDay] = useState(6);

  function getPreviousMonday() {
    var date = new Date();
    var day = date.getDay();
    var prevMonday = new Date();
    if (date.getDay() == 0) {
      prevMonday.setDate(date.getDate() - 7);
    } else {
      prevMonday.setDate(date.getDate() - (day - 1));
    }

    return prevMonday;
  }

  const history = useHistory();

  const { id } = props.match.params;

  const { data } = useQuery(GET_EVENT_BY_ID, {
    client: hasuraClient,
    fetchPolicy: "cache-and-network",
    variables: {
      id: id,
      userId: localStorage.getItem("user_id"),
      current_date_time: moment().format(),
    },
  });

  const [DeleteEventMutation] = useMutation(DELETE_EVENT, {
    client: hasuraClient,
  });

  const { data: allCategories } = useQuery(GET_CATEGORIES, {
    client: hasuraClient,
    fetchPolicy: "cache-and-network",
  });

  const { data: lineChartData } = useQuery(GET_EVENT_INCOME_LINE_CHART, {
    client: monoClient,
    fetchPolicy: "cache-and-network",
    variables: {
      startDate: moment(startDate).format("YYYY-MM-DD"),
      endDate: moment(endDate).add(1, "day").format("YYYY-MM-DD"),
      event_id: id,
    },
  });

  const { data: ticketSoldData } = useQuery(GET_TICKET_SOLD, {
    client: hasuraClient,
    fetchPolicy: "cache-and-network",
    variables: {
      event_id: id,
    },
  });

  const { data: eventLastTransData } = useQuery(GET_EVENT_LAST_TRANS, {
    client: hasuraClient,
    fetchPolicy: "cache-and-network",
    variables: {
      event_id: id,
      // limit: 5,
    },
  });

  const { data: eventRedeemData } = useQuery(GET_REDEEM_DATA, {
    client: hasuraClient,
    fetchPolicy: "cache-and-network",
    variables: {
      id: id,
    },
  });

  useEffect(() => {
    if (lineChartData && lineChartData?.getEventIncomeStatistics?.length) {
      let arr = [
        {
          id: "council",
          data: [],
        },
      ];
      for (
        let i = 0;
        i < lineChartData?.getEventIncomeStatistics?.length;
        i++
      ) {
        arr[0].data.push({
          x: new Date(lineChartData?.getEventIncomeStatistics[i]?.x),
          y: lineChartData?.getEventIncomeStatistics[i]?.y,
        });
      }

      setGraphData(arr);
    }
  }, [lineChartData]);

  const deleteEvent = (idVal) => {
    DeleteEventMutation({
      variables: {
        id: idVal,
      },
    }).then(() => {
      history.push("/event");
    });
  };

  const onClickViewAllTicketSales = (idVal) => {
    history.push(`/event-details-data/${idVal}`);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (data) {
      setStartTime(
        moment(new Date(data?.events_by_pk?.start_date_time)).format("hh:mm A")
      );

      setEndTime(
        moment(new Date(data?.events_by_pk?.end_date_time)).format("hh:mm A")
      );

      setDates(
        moment(new Date(data?.events_by_pk?.date_time)).format("dddd, DD MMMM")
      );

      var categoryVal = "";
      var categoryImageVal = "";
      allCategories?.categories?.map(({ id, name, image_url }) => {
        if (data?.events_by_pk?.categories === id) {
          categoryVal = name;
          categoryImageVal = image_url;
        }
      });

      setCategory(categoryVal);
      setCategoryImage(categoryImageVal);
    }
  }, [data]);

  let getWeek = {
    0: "SUN",
    1: "MON",
    2: "TUE",
    3: "WED",
    4: "THU",
    5: "FRI",
    6: "SAT",
  };

  const onChange = (datesVal) => {
    const [start, end] = datesVal;
    setStartDateRange(start);
    setEndDateRange(end);
    setStartDate(start);
    setEndDate(end);
    if (start && end) {
      let startDay = new Date(start).getTime();

      let endDay = new Date(end).getTime();

      setDiffDay((endDay - startDay) / (1000 * 3600 * 24));
    }
  };

  return (
    <MainContainer active="events">
      <DeleteEvent
        deleteEventHandler={deleteEvent}
        show={modalShowD}
        onHide={() => setModalShowD(false)}
        id={id}
      />
      <section className="event-free-block">
        <div className="event-free-header">
          <div className="event-col-left">
            <div className="event-heading">
              <Link to="/event">
                <img src={Arrow} alt="arrow right" />
              </Link>
              <h3>{data?.events_by_pk?.name}</h3>
            </div>
            <div className="event-profile">
              <div className="icon">
                <img
                  src={
                    data?.events_by_pk?.council_profile
                      ?.council_profile_photo || UserIcons
                  }
                  alt="profile"
                />
              </div>
              <div className="event-content">
                <h3>Hosted By</h3>
                <p>{data?.events_by_pk?.council_profile?.name}</p>
              </div>
            </div>
          </div>
          <div className="event-col-right submit">
            <a
              onClick={() => {
                setModalShowD(true);
              }}
              href="javascript:void(0)"
              className="back-btn"
            >
              Delete event
            </a>
            <Link to={`/edit-event/${id}`} className="submit-btn">
              Edit event
            </Link>
          </div>
        </div>

        <div className="event-full-image">
          <div className="image">
            <img src={data?.events_by_pk?.cover_photo} alt="event image" />
          </div>
          <div className="social-button">
            {/* <button className="button">
              <span className="icon">
                <img src={like} alt="like" />
              </span>
              <p>
                {data?.events_by_pk?.event_likes_aggregate?.aggregate?.count}{" "}
                likes
              </p>
            </button> */}
            {/* <button className="button">
              <span className="icon">
                <img src={download} alt="download" />
              </span>
              <p>0 shared</p>
            </button> */}
          </div>
        </div>

        <div className="event-free-details">
          <div className="event-col-71">
            <div className="event-details">
              <h2>Description</h2>
              <p>{data?.events_by_pk?.description}</p>
              <div className="attendes-row">
                <div className="main-title">
                  <h2>
                    Attendees{" "}
                    <span className="count">
                      (
                      {
                        data?.events_by_pk?.total_event_attendees?.aggregate
                          ?.count
                      }
                      )
                    </span>
                  </h2>
                  {data?.events_by_pk?.event_attendees &&
                  data?.events_by_pk?.event_attendees?.length > 3 ? (
                    <a
                      variant="primary"
                      onClick={() => setModalShow(true)}
                      className="view-all"
                      style={{ cursor: "pointer" }}
                    >
                      View all
                    </a>
                  ) : (
                    ""
                  )}

                  <Attendees
                    show={modalShow}
                    count={
                      data?.events_by_pk?.total_event_attendees?.aggregate
                        ?.count
                    }
                    data={data?.events_by_pk?.event_attendees}
                    onHide={() => setModalShow(false)}
                  />
                </div>
                <ul className="attendees-list">
                  {data?.events_by_pk?.event_attendees?.map(
                    ({ users_view }, index) => {
                      if (index < 3) {
                        return (
                          <li>
                            <div className="attendees-box">
                              <div className="attendees-img">
                                <img
                                  src={users_view?.profile_photo || UserIcons}
                                  alt="photo"
                                />
                              </div>
                              <h3>{users_view?.full_name}</h3>
                            </div>
                          </li>
                        );
                      }
                    }
                  )}
                </ul>
              </div>
            </div>
          </div>
          <div className="event-col-29">
            <div className="main-title">
              <h2>Details</h2>
            </div>
            <div className="event-name">
              <div className="event-image">
                {data?.events_by_pk?.council_profile?.council_profile_photo ? (
                  <img src={categoryImage} alt="event" />
                ) : (
                  <div className="image-bg"></div>
                )}
              </div>
              <div className="content">
                <h3>{data?.events_by_pk?.council_profile?.name}</h3>
                <p>{category}</p>
              </div>
            </div>

            <div className="event-location-row">
              <ul>
                <li>
                  <div className="event-location-block">
                    <div className="icon">
                      <img src={time} alt="clock icon" />
                    </div>
                    <div className="location-content">
                      <h3>{dates}</h3>
                      <p>{`${startTime} - ${endTime}`}</p>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="event-location-block">
                    <div className="icon">
                      <img src={location} alt="clock icon" />
                    </div>
                    <div className="location-content">
                      <h3> {data?.events_by_pk?.location?.location_text}</h3>
                      {/* <p>{data?.events_by_pk?.location?.location_text}</p> */}
                    </div>
                  </div>
                </li>
                <li>
                  <div className="event-location-block">
                    <div className="icon">
                      <img src={calender} alt="clock icon" />
                    </div>
                    <div className="location-content">
                      <h3>{data?.events_by_pk?.event_payment_type} Event</h3>

                      {data?.events_by_pk?.event_payment_type === "free"
                        ? data?.events_by_pk?.event_paid_ticket_details?.map(
                            (tickets) => {
                              return (
                                <p>
                                  {tickets?.option_name} X{" "}
                                  {tickets?.quantity_available} ticket
                                </p>
                              );
                            }
                          )
                        : data?.events_by_pk?.event_paid_ticket_details?.map(
                            (tickets) => {
                              return (
                                <p>
                                  {tickets?.option_name} ${tickets?.price} X{" "}
                                  {tickets?.quantity_available}{" "}
                                  {tickets?.quantity_available > 1
                                    ? "tickets"
                                    : "ticket"}
                                </p>
                              );
                            }
                          )}
                      {/* {data?.events_by_pk?.event_payment_type === "free"
                          ? `${ticketPrice} x ${ticketCount}`
                          : `${ticketPrice} x ${ticketCount}`} */}
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="ticket-section">
        <div className="ticket-sales-main">
          <div className="ticket-sales-cover">
            <div className="main-title">
              <h2>Ticket Sales</h2>
              {eventLastTransData?.event_attendees?.length ? (
                <a
                  href="javascript:void(0)"
                  onClick={() => {
                    onClickViewAllTicketSales(id);
                  }}
                >
                  View all
                </a>
              ) : (
                ""
              )}
            </div>
            <div className="ticket-row">
              <div className="ticket-col-50">
                <ul className="sales-left">
                  {eventLastTransData?.event_attendees?.length
                    ? eventLastTransData?.event_attendees?.map((data, index) =>
                        index < 4 ? (
                          <li>
                            <div className="icon">
                              <img src={cart} alt="icon" />
                            </div>
                            <div className="sales-cotnent">
                              <h3> {data?.users_view?.full_name} </h3>
                              <p>
                                {data?.quantity}{" "}
                                {data?.event_paid_ticket_detail?.option_name}{" "}
                                Tickets -
                                {getWeek[new Date(data?.created_at).getDay()]}{" "}
                                {moment(data?.created_at).format("DD MMM")}
                              </p>
                            </div>
                          </li>
                        ) : (
                          ""
                        )
                      )
                    : "No Data Found..."}
                </ul>
              </div>
              <div className="ticket-col-50">
                <div className="sales-right-row">
                  <div className="ticket-sold-row">
                    <h4>Tickets Sold</h4>
                    <div className="progeress-bar">
                      <label>
                        {ticketSoldData?.events_by_pk?.event_attendees_aggregate
                          ?.aggregate?.sum?.quantity ?? 0}
                        <span>
                          {ticketSoldData?.events_by_pk?.total_attendees ?? 0}{" "}
                        </span>
                      </label>
                      <Progress
                        theme={{
                          active: {
                            color: "#32D9B1",
                          },
                        }}
                        percent={
                          isNaN(
                            (
                              (ticketSoldData?.events_by_pk
                                ?.event_attendees_aggregate?.aggregate?.sum
                                ?.quantity /
                                ticketSoldData?.events_by_pk?.total_attendees) *
                              100
                            ).toFixed(2)
                          )
                            ? 0
                            : (
                                (ticketSoldData?.events_by_pk
                                  ?.event_attendees_aggregate?.aggregate?.sum
                                  ?.quantity /
                                  ticketSoldData?.events_by_pk
                                    ?.total_attendees) *
                                100
                              ).toFixed(2)
                        }
                      />
                    </div>
                  </div>
                  <div className="ticket-sold-row">
                    <h4>Tickets Redeemed</h4>
                    <div className="progeress-bar">
                      <label>
                        {eventRedeemData?.event_attendees_aggregate?.aggregate
                          ?.sum?.quantity ?? 0}
                        <span>
                          {ticketSoldData?.events_by_pk
                            ?.event_attendees_aggregate?.aggregate?.sum
                            ?.quantity ?? 0}
                        </span>
                      </label>
                      <Progress
                        theme={{
                          active: {
                            color: "#32D9B1",
                          },
                        }}
                        percent={
                          isNaN(
                            (
                              (eventRedeemData?.event_attendees_aggregate
                                ?.aggregate?.sum?.quantity /
                                ticketSoldData?.events_by_pk
                                  ?.event_attendees_aggregate?.aggregate?.sum
                                  ?.quantity) *
                              100
                            ).toFixed(2)
                          )
                            ? 0
                            : (
                                (eventRedeemData?.event_attendees_aggregate
                                  ?.aggregate?.sum?.quantity /
                                  ticketSoldData?.events_by_pk
                                    ?.event_attendees_aggregate?.aggregate?.sum
                                    ?.quantity) *
                                100
                              ).toFixed(2)
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {data?.events_by_pk?.event_payment_type !== "free" ? (
          <div className="shares-event-row">
            <div className="main-title">
              <h2>Ticket Income</h2>
            </div>
            <div className="share-event-chart-block">
              <div className="datepicker-row">
                <DatePicker
                  selected={startDateRange}
                  dropdownMode="select"
                  autoComplete="off"
                  onChange={onChange}
                  startDate={startDateRange}
                  endDate={endDateRange}
                  className="react-time-input"
                  calendarClassName="react-time-picker"
                  popperClassName="react-time-propper"
                  maxDate={new Date()}
                  selectsRange
                />
              </div>
              <div className="bar-chart-row">
                {data?.events_by_pk?.event_payment_type === "free" ? (
                  // <MyResponsiveBar />
                  ""
                ) : (
                  <MyResponsiveBump data={graphData} diffOfDays={diffDay} />
                )}
              </div>
              {/* {data?.events_by_pk?.event_payment_type === "free" ? (
              <div className="bar-bottom">
                <div className="bar-left">
                  <p>Event shares</p>
                </div>
                <div className="bar-right">
                  <p>
                    10.0%<span>283</span>
                  </p>
                </div>
              </div>
            ) : null} */}
            </div>
          </div>
        ) : (
          ""
        )}
      </section>
    </MainContainer>
  );
};

export default EventFree;
